<div id="PG_ApplicationSubmissionSummary" class="glb_formBGColor glb_boxedPadding glb_Font text-white glb_Font">
    <div class="glb_Font header-padding glb_customFlexRow">
        <div class="glb_customFlexRow col-12 glb_paddingZeroOffset">
            <div class="col-12 glb_customFlexRow glb_paddingBottomMD align-items-center glb_paddingZeroOffset">
                <div class="glb_TitleLG glb_TitleLGMobile text-start glb_fontColorSkin glb_breakLongWords glb_paddingZeroOffset col-6">
                    Recent Applications
                </div>
                <div class="col-6 glb_customFlexRow justify-content-end">
                    <div
                        class="glb_customFlexRow justify-content-lg-end justify-content-md-end justify-content-sm-end justify-content-xs-start align-items-end">
                        <div *ngIf="!IsLoadingInProgress" class="glb_rightAlignedContentPadding">
                            <button tabindex="2" class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white"
                                (click)="ApplicationSubmissionSummary_Refresh()">
                                <fa-icon [icon]="['fal', 'sync-alt']" class="fa-fw glb_fixedSizeIcons glb_clickableIconButtonColorDark"
                                    matTooltip="Click to Refresh">
                                </fa-icon>
                            </button>
                        </div>
                        <div *ngIf="IsLoadingInProgress" class="glb_rightAlignedContentPadding">
                            <button class="glb_standardButton btn glb_BGColorSkin text-white glb_positionRelative">
                                <fa-icon [icon]="['fal', 'compact-disc']"
                                    class="fa-fw glb_fastSpin glb_fixedSizeIcons glb_clickableIconButtonColorDark"
                                    matTooltip="Loading...Please wait"></fa-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <br>
        <div class="col-md-12 col-lg-12">

            <div
                class="glb_forceMarginAuto glb_customFlexRow row-cols-1 row-cols-sm-3 row-cols-md-3 row-cols-lg-3 justify-content-center align-items-center glb_paddingBottomMD">
                <div>
                    <!-- This tries to mimic how a mat-form-field-label looks on the autocomplete or control types -->
                    <input class="glb_formInputBoxDark glb_skinLightOutline glb_Font text-white" (keyup)='FilterSearchValueKeyUp.next($event)'
                        [(ngModel)]='FilterSearchValue' cdkFocusInitial tabindex="1" type="name" placeholder="Filter">
                </div>
                <div class="glb_customFlexRow justify-content-start align-items-end">
                    <span style="padding-left:0.375em;">
                        <button
                            class="glb_clickableIconButtonStyle glb_clickableIconButtonColorDark glb_clickableIconButtonMD btn-secondary align-self-right"
                            (click)="ApplicationSubmissionSummaryFilter_Clear()">
                            <fa-icon class="fa-fw glb_fixedSizeIcons" [icon]="['fal', 'eraser']" matTooltip="Clear search filter">
                            </fa-icon>
                        </button>
                    </span>
                </div>
                <div class="glb_customFlexRow justify-content-end align-items-center">
                    <button id="BTN_NewApplication" class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white"
                        (click)="NewApplication_Launch()">
                        <span class="glb_Font glb_smallerText">New Application</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="glb_allBordersSkin glb_Font col-12 glb_customFlexRow glb_PaddingHorizontalMD">
                <div class="glb_customFlexRow col-12 glb_paddingZeroOffset">
                    <div
                        class="glb_thinBottomWhiteBorder glb_customFlexRow col-12 glb_paddingZeroOffset row-cols-8 headerStyle glb_paddingTopSM glb_paddingBottomSM">
                        <div class="glb_customFlexRow align-items-center">
                            <div>Application ID</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div>Originator Reference Number</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div>Lender</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div>Product</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div>Principal Borrower</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div>Approved Amount</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div>Submitted Date</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div>Status</div>
                        </div>
                    </div>
                    <div class="glb_customFlexRow col-12 glb_paddingZeroOffset">
                        <div class="col-12 glb_minHeight300 glb_maxHeight800" style="overflow-y:auto; overflow-x:hidden; overflow-wrap: normal;">

                            <!-- Loop through applications to display them -->
                            <div class="glb_thinBottomWhiteBorder glb_XSPaddingBottomSM glb_XSPaddingTopSM glb_customFlexRow col-12 glb_paddingZeroOffset row-cols-8"
                                *ngFor="let application of ApplicationSubmissionSummaryList">

                                <!-- Application ID -->
                                <div class="glb_customFlexRow align-items-center glb_TextAlignMobileCentered">
                                    <div class="cell-data">
                                        <div class="cell-data-wrap">
                                            <a class="glb_ToolTippedContent hyperlinkID glb_hoverHand"
                                                (click)="ApplicationDetails_View(application.ApplicationID)">
                                                {{application.ApplicationID}}
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <!-- Reference Number -->
                                <div class="glb_customFlexRow align-items-center glb_TextAlignMobileCentered">
                                    <div class="cell-data">
                                        <div class="cell-data-wrap">
                                            <span *ngIf="application.DisableReferenceToolTip" class="glb_ToolTippedContent">
                                                {{application.ReferenceNumber}}
                                            </span>
                                            <span *ngIf="!application.DisableReferenceToolTip" matTooltip="{{application.ReferenceNumber}}"
                                                class="glb_ToolTippedContent">
                                                {{application.ReferenceNumber.substring(0, TextDisplayLimitReference) + '...'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Lender -->
                                <div class="glb_customFlexRow align-items-center glb_TextAlignMobileCentered">
                                    <div class="cell-data">
                                        <div class="cell-data-wrap">
                                            <span *ngIf="application.DisableLenderToolTip" class="glb_ToolTippedContent">
                                                {{application.Lender}}
                                            </span>
                                            <span *ngIf="!application.DisableLenderToolTip" matTooltip="{{application.Lender}}"
                                                class="glb_ToolTippedContent">
                                                {{application.Lender.substring(0, TextDisplayLimit) + '...'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Product -->
                                <div class="glb_customFlexRow align-items-center glb_TextAlignMobileCentered">
                                    <div class="cell-data">
                                        <div class="cell-data-wrap">
                                            <span *ngIf="application.DisableProductToolTip" class="glb_ToolTippedContent">
                                                {{application.Product}}
                                            </span>
                                            <span *ngIf="!application.DisableProductToolTip" matTooltip="{{application.Product}}"
                                                class="glb_ToolTippedContent">
                                                {{application.Product.substring(0, TextDisplayLimit) + '...'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Applicant Name -->
                                <div class="glb_customFlexRow align-items-center glb_TextAlignMobileCentered">
                                    <div class="cell-data">
                                        <div class="cell-data-wrap">
                                            <span *ngIf="application.DisableApplicantToolTip" class="glb_ToolTippedContent">
                                                {{application.ApplicantName}}
                                            </span>
                                            <span *ngIf="!application.DisableApplicantToolTip" matTooltip="{{application.ApplicantName}}"
                                                class="glb_ToolTippedContent">
                                                {{application.ApplicantName.substring(0, TextDisplayLimit) + '...'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Requested Amount -->
                                <div class="glb_customFlexRow align-items-center glb_TextAlignMobileCentered">
                                    <div class="cell-data">
                                        <div class="cell-data-wrap">
                                            {{application.RequestedAmount_FMT}}
                                        </div>
                                    </div>
                                </div>

                                <!-- Submission Date -->
                                <div class="glb_customFlexRow align-items-center glb_TextAlignMobileCentered">
                                    <div class="cell-data">
                                        <div class="cell-data-wrap">
                                            {{application.SubmissionDate_FMT}}
                                        </div>
                                    </div>
                                </div>

                                <!-- Status -->
                                <div class="glb_customFlexRow align-items-center glb_TextAlignMobileCentered">
                                    <div class="cell-data">
                                        <div class="cell-data-wrap">
                                            <span [ngClass]="{
                        'text-success': application.Status === 'Submitted',
                        'text-warning': application.Status === 'Approved with Warnings'}">{{application.Status}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="glb_customFlexRow col-12 row-cols-1 justify-content-center align-items-center glb_paddingBottomXS">
        <div class="col-12 glb_customFlexRow justify-content-center glb_Font">
            <div class="btn-group" role="group" aria-label="Basic example">
                <!-- Pagination controls -->
                <ngb-pagination *ngIf="ApplicationSubmissionSummaryList && ApplicationSubmissionSummaryList.length > 0" [maxSize]="Paging.maxSize"
                    [collectionSize]="ApplicationSubmissionSummaryList.length" [(page)]="CurrentPage" aria-label="Default pagination"
                    (pageChange)="Page_OnChange($event)">
                </ngb-pagination>
            </div>
        </div>
    </div>
</div>